module.exports = __webpack_public_path__ + "static/img/bg.ffe0f9d7.png";